<script lang="ts">
  import { inertia } from "@inertiajs/svelte"
  import type { Snippet } from "svelte"
  import { locale } from "svelte-i18n"

  import MarketingSeo from "@/components/marketing-seo.svelte"
  import MarketingShell from "@/layouts/marketing-shell.svelte"
  import { BRAND_NAME } from "@/lib/brand"
  import { localized } from "@/lib/locale-routes"

  type Props = {
    title?: string
    description?: string
    parent?: string
    parentHref?: string
    children?: Snippet
  }
  const { title, description, parent, parentHref, children }: Props = $props()

  // Frontmatter gives an unprefixed parentHref (e.g. "/legal"); keep the
  // breadcrumb in the page's current locale.
  const parentHrefLocalized = $derived(
    parentHref ? localized(parentHref, $locale ?? "en") : undefined,
  )
</script>

<MarketingSeo
  title={title ? `${title} — ${BRAND_NAME}` : BRAND_NAME}
  {description}
/>

<MarketingShell>
  <main class="mx-auto max-w-6xl px-6 pt-16 pb-24 sm:pt-24">
    {#if parent && parentHref}
      <nav
        class="mb-6 max-w-2xl text-sm text-[#706f6c] dark:text-[#A1A09A]"
        aria-label="Breadcrumb"
      >
        <a href={parentHrefLocalized} use:inertia class="hover:underline"
          >{parent}</a
        >
        <span class="px-1.5 text-[#c8c7c2] dark:text-[#3a3a37]">/</span>
        <span aria-current="page">{title}</span>
      </nav>
    {/if}
    <article class="prose dark:prose-invert max-w-2xl">
      {@render children?.()}
    </article>
  </main>
</MarketingShell>
